import React, { CSSProperties, ReactNode } from 'react';
import styled from '@emotion/styled';
import { StatusBadge } from '../../../../components/StatusBadge';

const StyledErrorBadgeContainer = styled('div')`
  display: flex;
  align-items: center;
`;

export const ErrorBadge = ({
  title,
  id,
  style,
  children,
}: {
  title?: string;
  /** Id of the screen-reader text, for a row's aria-describedby. */
  id?: string;
  style?: CSSProperties;
  children?: ReactNode;
}) => (
  <StyledErrorBadgeContainer style={style}>
    {/* Visual only, `title` tooltip included: screen readers get the sr-only text, once. */}
    <StatusBadge
      severity="error"
      badgeContent="!"
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      title={title}
      aria-hidden
      sx={{ pl: 16 }}
    />
    {title && (
      <span id={id} className="sr-only">
        {title}
      </span>
    )}
    {children && <div>{children}</div>}
  </StyledErrorBadgeContainer>
);
